import * as React from "react"

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 45 45"
    style={{
      enableBackground: "new 0 0 45 45",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <path fill={props.background} d="m36.9 16.7.1-.1V16.3c0-8-6.5-14.5-14.5-14.5S8 8.3 8 16.3V16.6c0 .1.1.1.1.1s0 .1.1.1l12.7 13.9H17c-.4 0-.8.3-.8.8v11c0 .4.3.8.8.8h11c.4 0 .8-.3.8-.8v-11c0-.4-.3-.8-.8-.8h-3.8l12.7-14c0 .1 0 0 0 0zM21.8 29.5 9.5 16c.3-1.3 2.8-3.1 6.1-3.1 3.5 0 6.1 2.1 6.1 3.4v13.2zm1.4-13.2c0-1.3 2.6-3.4 6.1-3.4 3.3 0 5.8 1.8 6.1 3.1L23.2 29.5V16.3zm-.7-13.1c6.1 0 11.3 4.2 12.7 10-1.4-1.1-3.6-1.8-5.8-1.8-2.9 0-5.6 1.2-6.9 2.9-1.3-1.7-4-2.9-6.9-2.9-2.2 0-4.3.7-5.8 1.8 1.4-5.7 6.6-10 12.7-10zm4.8 38.6h-9.5v-9.5h9.5v9.5z" />
    <path fill={props.background} d="M21.8 39.7c0 .4.3.8.8.8h2.8c.4 0 .8-.3.8-.8s-.5-.7-.9-.7h-2.8c-.4 0-.7.3-.7.7z" />
  </svg>
)

export default SvgComponent
